import { CommonModule } from '@angular/common';
import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { FullQuizData } from '@edtech-ui/core/models/quiz-creation/ai-quiz-generator';
import { QuizManagementService } from '@edtech-ui/core/services/quiz-management/quiz-management.service';
import { ToastrService } from 'ngx-toastr';
import { Subscription } from 'rxjs';
@Component({
	selector: 'app-question-preview',
	standalone: true,
	imports: [CommonModule, FormsModule],
	templateUrl: './question-preview.component.html',
	styleUrl: './question-preview.component.scss'
})

export class QuestionPreviewComponent implements OnInit, OnDestroy {

	@Input() isPreviewVisible: boolean = false;
	subscription = new Subscription();
	_quizData: FullQuizData | null = null;
	quizId!:string;

	constructor(
		private _quizService: QuizManagementService,
		private _toastr: ToastrService,
		private route:ActivatedRoute,
	) { }

	ngOnInit(): void {
		this.route.paramMap.subscribe(params => {
			this.quizId = params.get('quizId')!;
	});
		const userId = localStorage.getItem('user_id');

		if (!userId) {
			return;
		}

		const storageQuizDataKey = `${userId}_ai_quiz_data`;
		const quizDataStored = localStorage.getItem(storageQuizDataKey);
		if (quizDataStored) {
			try {
				const parsed = JSON.parse(quizDataStored);
				if (parsed?.questions?.length) {
					this._quizData = parsed;
					this.isPreviewVisible = true;
					this._quizService.saveQuizData.next(parsed);
				}
			} catch (error: any) {
				this._toastr.error('Failed to load data');
			}
		}
		this.getQuizData();
		if(this.quizId){
			this.getQuizDetailsById();
		}
	}

	getQuizData() {
		this.subscription.add(
			this._quizService.saveQuizData.subscribe(data => {
				if (data?.questions?.length) {
					this._quizData = data;
					const userId = localStorage.getItem('user_id')
					if (userId) {
						localStorage.setItem(`${userId}_ai_quiz_data`, JSON.stringify({ questions: data?.questions }));
					}
				}
			})
		);
	}

	getOptionLabel(index: number): string {
		const labels = ['A', 'B', 'C', 'D'];
		return labels[index] || '';
	}

	getQuizDetailsById() {
		if (this.quizId) {
			this.subscription.add(
				this._quizService.getQuizById(this.quizId).subscribe({
					next: (response) => {
						if (response.Success && response.Data) {
							this._quizData = response.Data;
							this.isPreviewVisible = true;
						}
						else {
							this._toastr.error(response.Message);
						}
					}
				}));
		}
	}

	ngOnDestroy(): void {
		this.subscription.unsubscribe();
	}
}